import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { punktartLegendGroups, PunktartLegendGroup } from '../data-model';

@Component({
	selector: 'bp-bohrpunkt-legende',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Symbol-Legende Bohrpunkte</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="modal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<div class="symbol-legend">
								<ng-container *ngFor="let g of legendGroups">
					<h6 class="legend-section">{{ g.kategorie }}</h6>
					<div class="legend-item" *ngFor="let r of g.rows" [class.legend-invisible]="r.invisible">
						<img *ngIf="!r.invisible" [src]="r.svgUrl" class="legend-icon" alt="">
						<span *ngIf="r.invisible" class="legend-badge" [style.color]="r.ohneSymbolColor">[{{ r.ohneSymbolLabel }}]</span>
						<span class="legend-nr">({{ r.nummer }})</span> {{ r.beschreibung }}
						<span *ngIf="r.invisible" class="legend-hint">(unsichtbar)</span>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-outline-secondary" (click)="modal.close()">Schließen</button>
		</div>
	`,
	styles: [`
		.symbol-legend {
			font-size: 0.85rem;
			max-height: 60vh;
			overflow-y: auto;
			border: 1px solid #dee2e6;
			border-radius: 4px;
			padding: 8px;
		}
		.legend-section {
			font-size: 0.8rem;
			color: #495057;
			margin: 10px 0 4px 0;
			padding-bottom: 2px;
			border-bottom: 1px solid #dee2e6;
		}
		.legend-section:first-child {
			margin-top: 0;
		}
		.legend-item {
			display: flex;
			align-items: center;
			gap: 6px;
			padding: 3px 0;
			border-bottom: 1px solid #f0f0f0;
		}
		.legend-item:last-child {
			border-bottom: none;
		}
		.legend-icon {
			width: 18px;
			height: 18px;
			object-fit: contain;
			flex-shrink: 0;
		}
		.legend-icon-lg {
			width: 32px;
			height: 32px;
			object-fit: contain;
			flex-shrink: 0;
		}
		.legend-badge {
			min-width: 18px;
			flex-shrink: 0;
			font-weight: 600;
			font-size: 0.72rem;
			font-style: normal;
			white-space: nowrap;
		}
		.legend-nr {
			color: #6c757d;
			font-size: 0.8rem;
			min-width: 50px;
		}
		.legend-invisible {
			color: #999;
			font-style: italic;
		}
		.legend-hint {
			color: #aaa;
			font-size: 0.75rem;
			margin-left: 4px;
		}
	`]
})
export class BohrpunktLegendeComponent {
	modal = inject(NgbActiveModal);
	/** Symbol-Legende (list-getrieben, Single Source aus der Punktarten-Liste). */
	legendGroups: PunktartLegendGroup[] = punktartLegendGroups();
}
